/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MyCalendarAssignmentDto } from './myCalendarAssignmentDto.schema';

export const ListOfMyCalendarAssignmentDto = zod.array(zod.lazy(() => MyCalendarAssignmentDto));

export type ListOfMyCalendarAssignmentDto = zod.input<typeof ListOfMyCalendarAssignmentDto>;
export type ListOfMyCalendarAssignmentDtoOutput = zod.output<typeof ListOfMyCalendarAssignmentDto>;
